import tw from "twin.macro";
import { ModulesStatesEnum } from "@/routes/area-aggregate/types/enums/modules-states.enum";
import Unfolded from "@/routes/area-aggregate/components/unfolded";
import Up from "@/routes/area-aggregate/components/up";
import { ProgressBar } from "@/routes/area-aggregate/components/progress-bar";

const ModulesSumByState = ({
  numberOfModulesAchieved,
  percentageOfModulesAchieved,
  achievedStateTranslation,
  numberOfModulesInArea,
  canopeesTranslation,
  isCompleted,
  stateToDisplay,
  onClick,
}: {
  numberOfModulesAchieved: number;
  percentageOfModulesAchieved: number;
  numberOfModulesInArea: number;
  canopeesTranslation: string;
  achievedStateTranslation: string;
  isCompleted: boolean;
  stateToDisplay:
    | ModulesStatesEnum.UNFOLDED
    | ModulesStatesEnum.UP
    | ModulesStatesEnum.FOLDED;
  onClick: () => void;
}) => {
  return (
    <div onClick={onClick}>
      <div
        css={[
          tw`flex items-center justify-between border p-2 shadow-[0_1.5px_1.5px_rgba(0,0,0,0.08)] border-gray-200 rounded-md cursor-pointer border-l-2`,
          !isCompleted && tw`border-l-modules-amberBase`,
          isCompleted && tw`border-l-modules-greenBase`,
        ]}
      >
        <div tw="flex items-center gap-2">
          <div tw="w-8 h-6 flex items-center justify-center">
            {stateToDisplay === ModulesStatesEnum.UNFOLDED ? (
              <Unfolded tw="pl-1" height={24} width={32} strokeWidth={2.5} />
            ) : (
              <Up tw="pl-1" height={32} width={24} strokeWidth={2.5} />
            )}
          </div>
          <span tw="text-sm font-medium">
            {canopeesTranslation} {achievedStateTranslation}
          </span>
        </div>
        <div tw="flex items-center gap-0.5">
          <span tw="text-sm font-bold">{numberOfModulesAchieved}</span>
          <span tw="text-sm font-medium text-gray-500">/</span>
          <span tw="text-sm font-medium text-gray-500">
            {numberOfModulesInArea}
          </span>
        </div>
      </div>
      <ProgressBar
        total={numberOfModulesInArea}
        isCompleted={isCompleted}
        progress={percentageOfModulesAchieved}
        remaining={numberOfModulesInArea - numberOfModulesAchieved}
      />
    </div>
  );
};

export default ModulesSumByState;
